import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ExternalBuyerMappingsActions } from '../actions/external-buyer-mappings.actions';

@Injectable({ providedIn: 'root' })
export class ExternalBuyerMappingsActionsFacade {
  private readonly _store = inject(Store);

  public uploadMappings(file: File, buyerId: string, buyerKey: string): void {
    this._store.dispatch(
      ExternalBuyerMappingsActions.uploadMappings({ file, buyerId, buyerKey }),
    );
  }

  public downloadMappings(buyerId: string, fileName: string): void {
    this._store.dispatch(
      ExternalBuyerMappingsActions.downloadMappings({
        buyerId,
        fileName,
      }),
    );
  }

  public resetUpload(): void {
    this._store.dispatch(ExternalBuyerMappingsActions.uploadMappingsReset());
  }

  public resetDownload(): void {
    this._store.dispatch(ExternalBuyerMappingsActions.downloadMappingsReset());
  }
}
